import React, { useEffect } from "react";
import { DivisionsContextImport } from "../../../provider/divisions/DivisionsContextProvider";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import SearchInput from "../../../widget/common/form/SearchInput";
import NoData from "../../../widget/common/ui/NoData";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import Div from "../../../widget/common/ui/Div";
import { TextBlock } from "../../../widget/common/ui/Text";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { textCase } from "../../../service/ui/UI";

const DivisionListing = (props: { screenMobileView: boolean }) => {
  const screenMobileView: boolean = props.screenMobileView;

  const {
    getDivisionList,
    onClickDivision,
    divisionList,
    showSearch,
    handleOnChange,
    clearSearch,
    searchValue,
  } = DivisionsContextImport();

  useEffect(() => {
    getDivisionList();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {divisionList == null ? (
        <Center className="h-100 py-3">{Loader.normal()}</Center>
      ) : (
        <>
          {showSearch && (
            <SearchInput
              name="search-division"
              placeHolder="search"
              handleOnChange={handleOnChange}
              onClickSuffix={clearSearch}
              value={searchValue}
              autoFocus={true}
              listLogic={screenMobileView ? true : false}
            />
          )}

          <>
            {divisionList.length === 0 ? (
              <NoData />
            ) : (
              <Listing fixedHieght={!screenMobileView}>
                {(divisionList ?? []).map((division, key) => (
                  <ListItem key={key}>
                    <div
                      role="button"
                      onClick={() => onClickDivision(division)}
                    >
                      <Div
                        fontName="book"
                        color="theme-sublabel"
                        fontSize="13_14"
                      >
                        <TextBlock
                          fontName="bold"
                          textColor="theme-label"
                          fontSize="16_17"
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: UtilityHelper.wrapKeyword(
                                division?.title!,
                                searchValue
                              ),
                            }}
                          />
                        </TextBlock>
                        <TextBlock
                          fontName="book"
                          textColor="theme-sublabel"
                          fontSize="13_14"
                        >
                          {textCase(division.description!)}
                        </TextBlock>
                      </Div>
                    </div>
                  </ListItem>
                ))}
              </Listing>
            )}
          </>
        </>
      )}
    </>
  );
};

export default DivisionListing;
